module.exports = __webpack_public_path__ + "static/img/anxun61.a52f0826.png";